import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

const venueTypes = [
  "Funeral Parlour",
  "Private Residence",
  "Unknown",
  "Chapel",
  "Church",
  "Crematorium",
  "Hall",
  "Other",
  "Tent",
];

const venueCapacities = [100, 0, 0, 480, 400, 0, 1450, 0, 200];

export default function TotalCapacityByVenueWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Total Capacity by Venue Type
        </Typography>

        <BarChart
          xAxis={[
            {
              data: venueTypes,
              scaleType: "band",
              label: "venue_type",
            },
          ]}
          yAxis={[
            {
              label: "capacity",
            },
          ]}
          series={[
            {
              data: venueCapacities,
            },
          ]}
          height={300}
        />
      </CardContent>
    </Card>
  );
}
